/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InterventionFeedbackBad } from '../models/InterventionFeedbackBad';
import type { InterventionFeedbackGood } from '../models/InterventionFeedbackGood';
import type { InterventionResource } from '../models/InterventionResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InterventionFeedbackService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Cloturer une intervention reussie
     * Marque l'intervention finalisee avec le `COMMENTAIRE` du technicien, passe toutes ses lignes de devis en etat realise, et date les travaux sur le devis s'ils ne l'etaient pas.
     * @param id
     * @param requestBody
     * @returns InterventionResource `InterventionResource`
     * @throws ApiError
     */
    public interventionFeedbackFinaliseGood(
        id: string,
        requestBody: InterventionFeedbackGood,
    ): CancelablePromise<InterventionResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/intervention_feedback/good/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Cloturer une intervention avec reserve
     * Marque l'intervention terminee (`COMMENTAIRE`), passe en realise uniquement les lignes `LIGNE_DEVIS_SAV`, et cree l'intervention de reprise decrite dans `NEXT_INTERVENTION` (type, duree, effectif, observation) sur le meme devis, a planifier. Avec `CREATE_NEW_ORDER`, cree aussi un bon de commande fournisseur pour les pieces a recommander.
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public interventionFeedbackFinaliseBad(
        id: string,
        requestBody: InterventionFeedbackBad,
    ): CancelablePromise<{
        new_intervention: string;
        bc_fourn_created: string;
        bc_fourn_details: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/intervention_feedback/bad/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
